var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-state-msg"},[_vm._v(" "+_vm._s(this.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }